export default __webpack_public_path__ + "static/media/cert.889a7d9a.jpg";